import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

//UI
import { Button, Modal, Table, Loader, Icon, Form, Divider, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import HeaderCatalog from "../../../components/headerCatalog";
import ActiveIcon from "../../../components/activeIcon";
import TicketRateCell from "../../../components/rates/ticketRateCell"
import StateRateCell from "../../../components/rates/stateRateCell"
import ChangeStateRateModal from "../../../components/rates/changeStateRateModal"

//Actions
import { deleteTicket } from "../../../redux/actions/rates/ticket/deleteTicket";
import { initialStateTicket } from "../../../redux/actions/rates/ticket/fetchTicket";
import { fetchTicketListCustom, initialStateTicketListCustom } from "../../../redux/slices/custom/rates/ticket/customTicketList.slice";

// Resources
import { scrollToTop } from "../../resources/utils";

export default function TicketList() {
  const { t } = useTranslation();
  let actualDate = new Date();
  let currentYear = actualDate.getFullYear();
  let airline = "";
  let state = 1;

  const ticketRateFilters = JSON.parse(localStorage.getItem("ticketRateFilters"));
  if (ticketRateFilters) {
    currentYear = ticketRateFilters.year;
    airline = ticketRateFilters.airline;
    state = ticketRateFilters.state;
  }

  const { register, handleSubmit, errors, getValues } = useForm();

  const ticketStateCustom = useSelector((state) => state.customTicketList);
  const ticketState = useSelector((state) => state.ticketReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTicketListCustom({ year: currentYear, airline_id: airline, state: state }));
    scrollToTop();
    return () => {
      dispatch(initialStateTicket());
      dispatch(initialStateTicketListCustom());
    };
  }, []);

  if (ticketStateCustom.fetching || ticketStateCustom.fetching) {
    return <Loader active inline />;
  }

  if (ticketState.message === "resource deleted successfully") {
    dispatch(fetchTicketListCustom({ year: getValues("year"), airline_id: getValues("airline_id"), state: getValues("state") }));
    dispatch(initialStateTicket());
  }

  if (ticketState.message === "resource updated successfully") {
    dispatch(fetchTicketListCustom({ year: getValues("year"), airline_id: getValues("airline_id"), state: getValues("state") }));
    dispatch(initialStateTicket());
  }

  const handleDeleteTicket = (ticket_id) => {
    dispatch(deleteTicket(ticket_id));
  };

  const onSubmit = (data) => {
    let ticketRateFilters = {
      year: getValues("year"),
      airline: getValues("airline_id"),
      state: getValues("state")
    };
    console.log(data)
    localStorage.setItem("ticketRateFilters", JSON.stringify(ticketRateFilters));
    dispatch(fetchTicketListCustom(data));
  };

  return (
    <>
      {ticketState.error ? (
        <Message negative content={t(ticketState.error)} />
      ) : (
        ""
      )}
      <HeaderCatalog title={t("ticket_title")} message={ticketStateCustom.message} to="/tickets/tickets_new" />
      <Divider />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>{t("ticket_year")}</label>
            <select name="year" aria-expanded="true" defaultValue={currentYear} ref={register({ required: true })}>
              {ticketStateCustom.years.map((year, index) => (
                <option key={index} value={year.year}>{year.year}</option>
              ))}
            </select>
            {errors.rate_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field>
            <label>{t("flight_airline")} *</label>
            <select name="airline_id" defaultValue={airline} aria-expanded="true" ref={register({ required: true })}>
              <option></option>
              {ticketStateCustom.airlines.map((airline) => (
                <option key={airline.id} value={airline.id}>{airline.name}</option>
              ))}
            </select>
            {errors.airline_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field>
            <label>{t("charter_state")}</label>
            <select name="state" defaultValue={state} aria-expanded="true" ref={register}>
              <option value="all">{t("all")}</option>
              <option value={1}>{t("active_tag")}</option>
              <option value={0}>{t("inactive_tag")}</option>
            </select>
          </Form.Field>
          <Form.Field>
            <label>&nbsp;</label>
            <Button type="submit" loading={ticketStateCustom.fetching ? true : false} color="green"><Icon name='search' />{t("search_button")}</Button>
          </Form.Field>
        </Form.Group>
      </Form>

      {ticketStateCustom.tickets !== undefined ? (
        <Table color="blue">
          <Table.Body>
            {ticketStateCustom.tickets.map((ticket) => (
              <>
                <Table.Row>
                  <Table.Cell colSpan='9'>
                    <div className="flex justify-between pt-3">
                      <div className=" flex flex-col p-2 text-[13px] ">
                        <div className="flex gap-3 items-center mt-[-13px] mb-5">
                          <p className="font-semibold mb-0">{t("flight_airline")}: </p>
                          <p >{ticket.airline_name}</p>
                        </div>
                        {
                          ticket.agency_name ?
                            <div className="flex gap-3 items-center mt-[-13px] mb-5">
                              <p className="font-semibold mb-0">{t("contract_agency")}: </p>
                              <p >{ticket.agency_name}</p>
                            </div>
                            :
                            <div className="flex gap-3 items-center mt-[-13px] mb-5 font-semibold">
                              {t("ticket_general")}
                            </div>
                        }
                        <div className="flex gap-3 items-center mt-[-13px] mb-5">
                          <p className="font-semibold mb-0">{t("ticket_route")}: </p>
                          <p >{ticket.departure_route} - {ticket.return_route}</p>
                        </div>
                        <StateRateCell activation_date={ticket.activation_date} inactivation_date={ticket.inactivation_date} reason_deactivation={ticket.reason_deactivation} />
                        <div className="flex gap-3 items-center mt-[3px] mb-5 text-sky-600">
                          <p className="font-semibold mb-0">{t("tour_conductor")}: </p>
                          <p >{ticket.tour_conductor} USD</p>
                        </div>
                      </div>
                    </div>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">{t("ticket_year")}</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">{t("ticket_foreingAdult")}</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">{t("ticket_foreingChild")}</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">{t("ticket_nationalAdult")}</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">{t("ticket_nationalChild")}</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">{t("ticket_colonistAdult")}</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">{t("ticket_sailor")}</Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>
                <Table.Row key={ticket.id} className='no-row-borders'>
                  <Table.Cell collapsing><ActiveIcon active={ticket.active} /></Table.Cell>
                  <Table.Cell>{ticket.year}</Table.Cell>
                  <Table.Cell >
                    <TicketRateCell
                      passenger_low_season={ticket.passengerPrice_foreingAdult_lowSeason}
                      operator_low_season={ticket.airlinePrice_foreingAdult_lowSeason}
                      passenger_high_season={ticket.passengerPrice_foreingAdult_highSeason}
                      operator_high_season={ticket.airlinePrice_foreingAdult_highSeason} />
                  </Table.Cell>
                  <Table.Cell>
                    <TicketRateCell
                      passenger_low_season={ticket.passengerPrice_foreingChild_lowSeason}
                      operator_low_season={ticket.airlinePrice_foreingChild_lowSeason}
                      passenger_high_season={ticket.passengerPrice_foreingChild_highSeason}
                      operator_high_season={ticket.airlinePrice_foreingChild_highSeason} />
                  </Table.Cell>
                  <Table.Cell>
                    <TicketRateCell
                      passenger_low_season={ticket.passengerPrice_nationalAdult_lowSeason}
                      operator_low_season={ticket.airlinePrice_nationalAdult_lowSeason}
                      passenger_high_season={ticket.passengerPrice_nationalAdult_highSeason}
                      operator_high_season={ticket.airlinePrice_nationalAdult_highSeason} />
                  </Table.Cell>
                  <Table.Cell>
                    <TicketRateCell
                      passenger_low_season={ticket.passengerPrice_nationalChild_lowSeason}
                      operator_low_season={ticket.airlinePrice_nationalChild_lowSeason}
                      passenger_high_season={ticket.passengerPrice_nationalChild_highSeason}
                      operator_high_season={ticket.airlinePrice_nationalChild_highSeason} />
                  </Table.Cell>
                  <Table.Cell>
                    <TicketRateCell
                      passenger_low_season={ticket.passengerPrice_colonistAdult_lowSeason}
                      operator_low_season={ticket.airlinePrice_colonistAdult_lowSeason}
                      passenger_high_season={ticket.passengerPrice_colonistAdult_highSeason}
                      operator_high_season={ticket.airlinePrice_colonistAdult_highSeason} />
                  </Table.Cell>
                  <Table.Cell>
                    <TicketRateCell
                      passenger_low_season={ticket.passengerPrice_sailor_lowSeason}
                      operator_low_season={ticket.airlinePrice_sailor_lowSeason}
                      passenger_high_season={ticket.passengerPrice_sailor_highSeason}
                      operator_high_season={ticket.airlinePrice_sailor_highSeason} />
                  </Table.Cell>
                  <Table.Cell collapsing>
                    {ticket.active != false ? (
                      <ChangeStateRateModal stateRate={ticket} typeRate="TicketRate" />
                    ) : (
                      null
                    )}
                    {(!ticket.active && !ticket.reason_deactivation) && (
                      <>
                        <Link to={`/tickets/${ticket.id}`}><Button circular color='blue' icon='pencil alternate' /></Link>
                        <Modal
                          closeOnDimmerClick={false}
                          trigger={
                            <Button circular color='red' icon='trash alternate' />
                          }
                          content={t("ticket_delete")}
                          actions={[
                            t("canceled_button"),
                            {
                              key: "eliminar",
                              content: t("delete_button"),
                              className: "delete_button icon_color",
                              onClick: () => handleDeleteTicket(ticket.id),
                            },
                          ]}
                          size="tiny"
                        />
                      </>)}
                  </Table.Cell>
                </Table.Row>
              </>
            ))}
          </Table.Body>
        </Table>
      ) : (
        ""
      )}
    </>
  );
}
